export const PAGE_LIMIT = 10;
